import { useMemo } from 'react'

import { characterIds } from '../constants'

export const brawlCharacterAsset = (id: string) => {
  return characterIds.includes(id)
}

export const useBrawlCharacterImage = (id?: string) => {
  return id ? `/images/brawlstars/characters/${id}.png` : null
}

export const useAssetColor = (id: string) => {
  return useMemo(() => {
    if (id === '5000000') return 'green'
    if (id === '5000022') return 'pink'
    if (id === '5000023') return 'purple'
    if (id === '5000001') return 'blue'
    if (brawlCharacterAsset(id)) return 'character'

    return 'yellow'
  }, [id])
}
